/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_DealInputs */

const cs_field_deal = /** @type {(inputs: Field_DealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchod`)
};

const en_field_deal = /** @type {(inputs: Field_DealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal`)
};

/**
* | output |
* | --- |
* | "Deal" |
*
* @param {Field_DealInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_deal = /** @type {((inputs?: Field_DealInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_DealInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_deal(inputs)
	return cs_field_deal(inputs)
});